var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLackOfDigital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 3.5H3C2.46957 3.5 1.96086 3.71071 1.58579 4.08579C1.21071 4.46086 1 4.96957 1 5.5V17.5C1 18.0304 1.21071 18.5391 1.58579 18.9142C1.96086 19.2893 2.46957 19.5 3 19.5H13C13.5304 19.5 14.0391 19.2893 14.4142 18.9142C14.7893 18.5391 15 18.0304 15 17.5V5.5C15 4.96957 14.7893 4.46086 14.4142 4.08579C14.0391 3.71071 13.5304 3.5 13 3.5H11M5 3.5C5 2.96957 5.21071 2.46086 5.58579 2.08579C5.96086 1.71071 6.46957 1.5 7 1.5H9C9.53043 1.5 10.0391 1.71071 10.4142 2.08579C10.7893 2.46086 11 2.96957 11 3.5M5 3.5C5 4.03043 5.21071 4.53914 5.58579 4.91421C5.96086 5.28929 6.46957 5.5 7 5.5H9C9.53043 5.5 10.0391 5.28929 10.4142 4.91421C10.7893 4.53914 11 4.03043 11 3.5M5 10.5H11M5 14.5H11",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLackOfDigital);
export default __webpack_public_path__ + "static/media/lack_of_digital.40f454659a197b5f873b68e9b81d76d7.svg";
export { ForwardRef as ReactComponent };